import { useEffect } from 'react';
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { checkLanguage } from "logic/reducers/changeLanguage"
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import PageStart from '../../Pages/Start';
import { alertUser } from 'logic/eventBeforeunload';

export default function NewTemplate() {
  useEffect(() => {
    window.addEventListener('beforeunload', alertUser);
    return () => {
      window.removeEventListener('beforeunload', alertUser);
    };
  }, []);

  const { i18n } = useTranslation();
  const language = useSelector(checkLanguage);
  useEffect(() => {
    if (language) {
      i18n.changeLanguage(language)
    }
  }, [language, i18n]);

  return (
    <Router>
      <Switch>
        <Route path="/" component={PageStart} />
      </Switch>
    </Router>
  )
}